import { render, staticRenderFns } from "./SettingsContainer.vue?vue&type=template&id=74c74f60&"
import script from "./SettingsContainer.vue?vue&type=script&lang=js&"
export * from "./SettingsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports